import { Stack } from '@karma/components';
import SkeletonItems from 'components/molecules/SkeletonItems/SkeletonItems';
import SkeletonSections from '../SkeletonSections/SkeletonSections';

const GlobalSearchSkeletonLoader = () => {
  return (
    <Stack spacing={32} fullWidth direction="column" alignItems="flex-start">
      <SkeletonItems.TITLE_GLOBAL_SEARCH />
      <SkeletonSections.GLOBAL_SEARCH_MY_ITEMS />
      <SkeletonSections.GLOBAL_SEARCH_RETAILERS />
      <SkeletonSections.GLOBAL_SEARCH_ITEMS />
    </Stack>
  );
};

export default GlobalSearchSkeletonLoader;
